import { makeStyles } from '@material-ui/core';

export default function NextPrevButtons(props) {

    const classes = useStyles();

    return (
        <div className={classes.container}>
            {
                props.hasPrevious
                    ?
                    <button className={classes.previousButton} onClick={() => props.SetPrevious()}>{"PREVIOUS"}</button>
                    : <div>
                    </div>
            }
            {
                props.hasNext
                    ?
                    <button className={classes.nextButton} onClick={() => props.SetNext()}>{"NEXT"}</button>
                    :
                    <button className={classes.button} onClick={() => props.SetNext()}>{"FINISH"}</button>
            }
        </div>
    )
}

const useStyles = makeStyles({
    container: {
        flex: 1,
        flexDirection: "row",
    },
  
    button: {
        fontFamily: "Roboto",
        outline: "none",
        border: "none",
        cursor: "pointer",
        backgroundColor: "#1976d2",
        color: "white",
        height: "30px",
        width: "80px",
        fontSize: "14px",
        marginTop: "10px",
        float: "right",

    },
    nextButton: {
        fontFamily: "Roboto",
        outline: "none",
        border: "none",
        cursor: "pointer",
        backgroundColor: "#1976d2",
        color: "white",
        height: "30px",
        width: "80px",
        fontSize: "14px",
        float: "right",
        marginTop: "10px"

    },
    previousButton: {
        fontFamily: "Roboto",
        outline: "none",
        border: "none",
        cursor: "pointer",
        backgroundColor: "#1976d2",
        color: "white",
        height: "30px",
        width: "80px",
        fontSize: "14px",
        float: "left",
        marginTop: "10px"

    }
});